import { render, staticRenderFns } from "./DieticiansNoteCard.vue?vue&type=template&id=1c63caa3&scoped=true&"
import script from "./DieticiansNoteCard.vue?vue&type=script&lang=js&"
export * from "./DieticiansNoteCard.vue?vue&type=script&lang=js&"
import style0 from "./DieticiansNoteCard.vue?vue&type=style&index=0&id=1c63caa3&prod&scoped=true&lang=css&"
import style1 from "./DieticiansNoteCard.vue?vue&type=style&index=1&id=1c63caa3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63caa3",
  null
  
)

export default component.exports